import { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space } from 'antd';
import { useSelector } from "react-redux";
import utils from './utils';
import { APIClient } from "../helpers/api_helper";
import { useDispatch } from 'react-redux';
import { loadPersons } from '../slices/thunk';


const api = new APIClient();


const PersonSelect = ({ value = [], onChange, multiple = false, size = null, minWidth = 200, allowCreate = true, placeholder='Izberi osebo'}) => {

  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');

  const opts = utils.processBackendOpts(useSelector((state) => state.Persons.list))
  const personsById = utils.processBackendOptsById(useSelector(state => state.Persons.byId))


  const createAndSelectNew = (e) => {

    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;

    const exists = opts.some(opt => opt.value === trimmed);
    if (exists){
      return;
    }

    api.post('/api/persons/', {'title': trimmed}, {successMsg: `Oseba ${trimmed} uspešno ustvarjena!`})
      .then(resp => {
        setName('');
        setOpen(false);
        onChange(resp?.id)
        dispatch(loadPersons());  // so redux (app-wide) persons are updated!
      })
  };

  const selectedValues = Array.isArray(value)
      ? value.map(x => personsById[x])
      : personsById[value];

  return (
    <Select
      open={open}
      onDropdownVisibleChange={setOpen}
      mode={multiple ? "multiple" : undefined}
      showSearch
      style={{ minWidth: minWidth, flex: 1 }}
      optionFilterProp="label"
      value={selectedValues}
      onChange={onChange}
      options={opts}
      allowClear
      size={size}
      placeholder={placeholder}
      dropdownRender={allowCreate ? (menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <Input
              placeholder="Vnesi ime osebe"
              ref={inputRef}
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => e.stopPropagation()}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={createAndSelectNew}>
              Ustvari novo osebo
            </Button>
          </Space>
        </>
      )) : undefined}
    />
  );
};

export default PersonSelect;
